import { OnInit } from '@angular/core';
import { Component, ViewChild, OnDestroy } from '@angular/core'; import { LayoutService } from './service/app.layout.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router'; import { environment } from 'src/environments/environment';
import { MenuItem } from 'primeng/api'; import { Capacitor } from '@capacitor/core';
import { Menu } from 'primeng/menu'; import { ColorScheme } from 'src/app/layout/service/app.layout.service';
import { HomeService } from 'src/app/services/home.service'; import { Auth401Service } from 'src/app/services/auth-401.service';
import { BillingService } from 'src/app/services/billing.service';
import { switchMap } from 'rxjs/operators';
@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit, OnDestroy {
    @ViewChild('menu') menu!: Menu;
    items!: MenuItem[];
    lojas = [
        { label: 'Loja ', value: 'loja1' },
        { label: 'Loja 2', value: 'loja2' },
    ];
    lojaSelecionada: string | null = null;
    model: any[] = [];

    constructor(
        private authService: AuthService,
        private router: Router,
        private auth401: Auth401Service,
        public layoutService: LayoutService,
        private homeService: HomeService,
        private billingService: BillingService) {
        console.log('[Capacitor] referenced in AppMenuComponent');
        this.lojaSelecionada = 'loja1';
    }

    mostrarDropdown: boolean = true;

    verExtrato() {
        this.router.navigate(['/extrato']);
    }

    formasPagamento() {
        // Lógica para "Formas de Pagamento"
    }

    taxasTarifas() {
        // Lógica para "Taxas e Tarifas"
    }
    openMenu(event: Event) {
        this.menu.toggle(event);
    }
    mostrarValores: boolean = true;
    carregando: boolean = false;
    atualizarValores() {
        this.carregando = true;
        const wallet = this.billingService.getWalletId();
        //////////////////////////////
        // this.homeService.balance(wallet)
        //     .subscribe(res => {

        //         this.saldoDisponivel = parseFloat(res.balance).toFixed(2);
        //         this.carregando = false;
        //     })

        // this.homeService.releaseBalance(wallet)
        //     .subscribe(res => {
        //         const saldo = parseFloat(res.balance).toFixed(2);
        //         this.saldoLiberar = saldo;
        //         this.carregando = false;
        //     })
    }

    alternarVisibilidade() {
        this.mostrarValores = !this.mostrarValores;
    }
    itemsButtons: MenuItem[] = [];
    itemsButtonsCobrar: MenuItem[] = [];
    itemsButtonsRetirar: MenuItem[] = [];
    saldoDisponivel: string = '0.00';
    saldoLiberar: string = '0.00';
    xT: number = 0;
    ngOnInit() {
        this.itemsButtonsCobrar = [
            { label: 'Links de pagamento', icon: 'pi pi-refresh' },
            { label: 'Links recentes', icon: 'pi pi-times' }
        ];
        this.itemsButtonsRetirar = [
            { label: 'Conta Bancária PIX', icon: 'pi pi-refresh' }
        ];
        this.items = [
            { label: 'Ver extrato', icon: 'pi pi-list', command: () => { this.verExtrato(); } },
            { label: 'Formas de Pagamento', icon: 'pi pi-credit-card', command: () => { this.formasPagamento(); } },
            { label: 'Taxas e Tarifas', icon: 'pi pi-tag', command: () => { this.taxasTarifas(); } }
        ];
        // this.model = [
        //     {
        //         items: [
        //             {
        //                 label: 'Dashbord',
        //                 icon: 'pi pi-fw pi-home',
        //                 routerLink: ['/']
        //             },
        //             {
        //                 label: 'Slicks',
        //                 icon: 'pi pi-fw pi-video',
        //                 routerLink: ['/lives']
        //             },
        //             {
        //                 label: 'Configurações',
        //                 icon: 'pi pi-fw pi-cog',
        //                 routerLink: ['/configurations']
        //             },
        //             // {
        //             //     label: 'Configurações',
        //             //     icon: 'pi pi-fw pi-cog',
        //             //     items: [
        //             //         {
        //             //             label: 'Player',
        //             //             icon: 'pi pi-fw pi-play',
        //             //             routerLink: ['/player']
        //             //         }
        //             //     ]
        //             // },
        //             // {
        //             //     label: 'Integrações',
        //             //     icon: 'pi pi-fw pi-globe',
        //             //     routerLink: ['/integrations']
        //             // },
        //         ]
        //     },
        //     {
        //         bottom: true,
        //         items: [
        //             {
        //                 label: 'Suporte',
        //                 icon: 'pi pi-fw pi-question-circle',
        //                 routerLink: ['/help']
        //             },
        //             // {
        //             //     label: 'Fale Conosco',
        //             //     icon: 'pi pi-fw pi-phone',
        //             //     routerLink: ['/contact']
        //             // },
        //             {
        //                 label: 'Sair',
        //                 icon: 'pi pi-fw pi-power-off',
        //                 command: () => this.resetUserToLogin()
        //             }
        //         ]
        //     }
        // ];

        this.model = [
            {
                items: [
                    { label: 'Analytics', icon: 'pi pi-fw pi-home', routerLink: ['/'] },
                    { label: 'Slicks', icon: 'pi pi-fw pi-video', routerLink: ['/slicks'] },
                    { label: 'Feeds', icon: 'bi bi-rss', routerLink: ['/feed'] },
                    { label: 'Widgets', icon: 'bi bi-grid-1x2', routerLink: ['/widgets'] },
                    { label: 'Apps', icon: 'bi bi-windows', routerLink: ['/apps'] },
                    { label: 'Configurações', icon: 'pi pi-fw pi-cog', routerLink: ['/configurations'] }
                ]
            },
            { separator: true },
            {
                items: [
                    { label: 'Meu Player', icon: 'bi bi-play', command: () => this.goToMyPlayer() },
                    { label: 'Suporte', icon: 'pi pi-fw pi-question-circle', command: () => window.open('https://helpcenterslicksell.tawk.help/', '_blank') },
                    { label: 'Sair', icon: 'pi pi-fw pi-power-off', command: () => this.resetUserToLogin() }
                ]
            },
            // 👇 entra como último <li> dentro da <ul>
            { custom: 'themeToggle' }
        ];


        if (this.xT == 0) {
            this.xT = 1;
            this.carregando = true;
            this.atualizacaoInterval = setTimeout(() => {
                this.atualizarValores();
            }, 1600);
        } else {
            this.atualizarValores();
        }

        //////////////////////////////
        //this.atualizarValores(); // Chama imediatamente ao iniciar
        this.atualizacaoInterval = setInterval(() => {
            this.atualizarValores();
        }, 120000); // 120000 milissegundos = 2 minutos
        //////////////////////////////

        const viewMode = localStorage.getItem('viewMode');
        this.darkMode = (viewMode === 'dark');
        this.selectedMode = this.darkMode ? 'dark' : 'light';
    }
    isMobile(): boolean {
        if (typeof window === 'undefined') return false; // guarda p/ SSR
        return window.matchMedia('(max-width: 991.98px)').matches;
    }
    modes = [
        { label: '', value: 'light', icon: 'pi pi-sun' },
        { label: '', value: 'dark', icon: 'pi pi-moon' }
    ];
    selectedMode: 'light' | 'dark' = 'light';
    onModeChange(mode: 'light' | 'dark') {
        this.selectedMode = mode;
        this.darkMode = (mode === 'dark');      // <-- mantém compatível com toggleTheme()
        this.toggleTheme();                     // <-- reaproveita seus métodos atuais
    }
    darkMode: boolean = false;
    toggleTheme(): void {
        // Determina o novo esquema com base no estado do switch const accessToken = localStorage.getItem('access_token');
        const newScheme = this.darkMode ? 'dark' : 'light';
        localStorage.setItem('viewMode', newScheme);
        this.changeColorScheme(newScheme as ColorScheme);
    }

    changeColorScheme(colorScheme: ColorScheme): void {
        const themeLink = document.getElementById('theme-link') as HTMLLinkElement;
        if (themeLink) {
            const themeLinkHref = themeLink.getAttribute('href');
            const currentColorScheme = 'theme-' + this.layoutService.config.colorScheme;
            const newColorScheme = 'theme-' + colorScheme;
            const newHref = themeLinkHref!.replace(currentColorScheme, newColorScheme);
            this.replaceThemeLink(newHref, () => {
                this.layoutService.config.colorScheme = colorScheme;
                this.layoutService.onConfigUpdate();
            });
        } else {
            console.error('Theme link element not found!');
        }
    }

    replaceThemeLink(href: string, onComplete: () => void): void {
        const id = 'theme-link';
        const themeLink = document.getElementById(id) as HTMLLinkElement;
        const cloneLinkElement = themeLink.cloneNode(true) as HTMLLinkElement;

        cloneLinkElement.setAttribute('href', href);
        cloneLinkElement.setAttribute('id', id + '-clone');

        themeLink.parentNode!.insertBefore(cloneLinkElement, themeLink.nextSibling);

        cloneLinkElement.onload = () => {
            themeLink.remove();
            cloneLinkElement.setAttribute('id', id);
            onComplete();
        };
    }
    private atualizacaoInterval: any;
    isSelected(item: any): boolean {
        return this.router.isActive(item.routerLink[0], true);
    }
    goToMyPlayer() {
        let domainStore = localStorage.getItem('domain_store');

        if (!domainStore) {
            const storeDataRaw = localStorage.getItem('store_data');

            if (storeDataRaw) {
                try {
                    const storeData = JSON.parse(storeDataRaw);

                    // ✅ na sua store_data é store_domain
                    domainStore =
                        storeData?.domain_store ??
                        storeData?.store_domain ??
                        null;

                } catch (error) {
                    console.error('Erro ao fazer parse de store_data:', error);
                }
            }
        }

        if (domainStore) {
            domainStore = String(domainStore).replace(/^https?:\/\//, '').replace(/\/$/, '');

            const subdomain = domainStore.split('.')[0];
            const url = `${environment.frontendUrl}/${subdomain}`;

            window.open(url, '_blank');
        } else {
            console.error('domain_store não encontrado nem direto nem dentro de store_data');
        }
    }


    // goToMyPlayer() {
    //     const domainStore = localStorage.getItem('domain_store');
    //     if (domainStore) {
    //         const url = `https://${domainStore}`;
    //         window.open(url, '_blank');
    //     } else {
    //         console.error('domain_store not found in localStorage');
    //     }
    // }
    ngOnDestroy() {
        if (this.atualizacaoInterval) {
            clearInterval(this.atualizacaoInterval);
        }
    }
    // resetUserToLogin(): void {
    //     this.authService.logout()
    //         .subscribe(res => {
    //             for (let i = localStorage.length - 1; i >= 0; i--) {
    //                 const key = localStorage.key(i);
    //                 if (key?.startsWith('cachedInstagramAccounts_') || key?.startsWith('user_detail_')) {
    //                     localStorage.removeItem(key);
    //                 }
    //             }
    //             localStorage.removeItem('access_token');
    //             localStorage.removeItem('access_token_ebanking');
    //             localStorage.removeItem('domain_store');
    //             localStorage.removeItem('SelectedStoreId');
    //             localStorage.removeItem('user_name');
    //             localStorage.removeItem('user_id');
    //             localStorage.removeItem('use_trial');
    //             localStorage.removeItem('wallet_id');
    //             localStorage.removeItem('user_chat');
    //             localStorage.removeItem('user_ip');
    //             localStorage.removeItem('store');
    //             localStorage.removeItem('store_data');
    //             this.router.navigate(['/auth/login']);
    //         }, err => {
    //             if (err.status === 401) {
    //                 localStorage.removeItem('access_token');
    //                 localStorage.removeItem('access_token_ebanking');
    //                 localStorage.removeItem('domain_store');
    //                 localStorage.removeItem('SelectedStoreId');

    //                 this.router.navigate(['/auth/login']);
    //             } else {
    //                 console.error('resetUserToLogin', err);
    //             }
    //         })
    // }

    async resetUserToLogin(): Promise<void> {
        try {
            await this.authService.logout();

            // Limpa todos os dados locais relevantes
            for (let i = localStorage.length - 1; i >= 0; i--) {
                const key = localStorage.key(i);
                if (key?.startsWith('cachedInstagramAccounts_') || key?.startsWith('user_detail_')) {
                    localStorage.removeItem(key);
                }
            }

            // Limpa tokens e outros dados
            localStorage.removeItem('access_token');
            localStorage.removeItem('access_token_ebanking');
            localStorage.removeItem('domain_store');
            localStorage.removeItem('SelectedStoreId');
            localStorage.removeItem('user_name');
            localStorage.removeItem('user_id');
            localStorage.removeItem('use_trial');
            localStorage.removeItem('wallet_id');
            localStorage.removeItem('user_chat');
            localStorage.removeItem('user_ip');
            localStorage.removeItem('store');
            localStorage.removeItem('store_data');
            localStorage.removeItem('oauth');
            localStorage.removeItem('socket_jwt');
            this.authService.clearUser();
            await this.auth401.forceLogout();

            this.router.navigate(['/auth/login']).then(() => {
                if (Capacitor.isNativePlatform()) {
                    // Em mobile pode forçar reload, se necessário
                    window.location.reload();
                }
            });

        } catch (err: any) {
            if (err.status === 401) {
                this.router.navigate(['/auth/login']);
            } else {
                console.error('Erro no logout:', err);
            }
        }
    }

}

